import User01Icon from "@untitled-ui/icons-react/build/esm/User01";
import {
  Avatar,
  Box,
  ButtonBase,
  SvgIcon,
  Typography,
  useMediaQuery,
  useTheme,
  Stack,
} from "@mui/material";

import { usePopover } from "src/hooks/use-popover";
import { AccountPopover } from "./account-popover";
import { useSelector } from "react-redux";
import { getSessionStorage } from "src/utils/storage";
import authAxios from "src/lib/axios";
import { useImagePreview } from "src/hooks/use-image-preview";

export const AccountButton = ({ expanded }) => {
  const fullName = useSelector((state) => state.user.fullName);
  const photoURL = getSessionStorage("photoUrl") || null;
  const avatarPreview = useImagePreview(photoURL, {
    axiosInstance: authAxios,
    fallbackToRawOnError: true,
  });
  const displayPhoto = avatarPreview || photoURL || null;
  const ownerEmail = getSessionStorage("ownerEmail") || null;
  //console.log({ photoURL });

  const user = {
    name: fullName,
    ownerEmail: ownerEmail,
    email: getSessionStorage("userEmail"),
    avatar: displayPhoto
      ? displayPhoto
      : "/assets/profile-image.png",
  };
  // //console.log(user);
  const popover = usePopover();
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));

  return (
    <>
      <Stack
        alignItems="center"
        direction="row"
        spacing={2}
        onClick={popover.handleOpen}
        sx={{ cursor: "pointer", mt: '5px' }}
      >
        <Box
          component={ButtonBase}
          //onClick={popover.handleOpen}
          ref={popover.anchorRef}
          sx={{
            alignItems: "center",
            display: "flex",
            borderWidth: 2,
            borderStyle: "solid",
            borderColor: "divider",
            height: 40,
            width: 40,
            borderRadius: "50%",
          }}
        >
          <Avatar
            sx={{
              height: 32,
              width: 32,
            }}
            src={user.avatar}
          >
            <SvgIcon>
              <User01Icon />
            </SvgIcon>
          </Avatar>
        </Box>
        {expanded && <Box>
          <Typography
            variant="body1"
            //color="text.primary"
            sx={{
              fontWeight: 700,
              color: "var(--nav-item-color)",
              fontSize: "18px",
              width: "200px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {user.name}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "var(--nav-item-color)",
              fontSize: "16px",
              width: "200px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {user.ownerEmail || user.email}
          </Typography>
        </Box>}
      </Stack>
      <AccountPopover
        anchorEl={popover.anchorRef.current}
        onClose={popover.handleClose}
        open={popover.open}
      />
    </>
  );
};
